"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function ProjectRepository() {
  const artifacts = [{
    id: 1,
    title: "Hackathon Finals",
    spec: "24-hour / intense coding",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hackathon_event.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hackathon_event.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hackathon_event.png-wvc-sizes",
      alt: "Hackathon event participants coding"
    },
    gridClasses: "lg:col-start-1 lg:col-end-5 lg:row-start-1 lg:row-end-3",
    aspectClasses: "aspect-[3/4]"
  }, {
    id: 2,
    title: "Passion Projects",
    spec: "Custom / open-source",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/member_project.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/member_project.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/member_project.png-wvc-sizes",
      alt: "Member passion project hardware"
    },
    gridClasses: "lg:col-start-5 lg:col-end-9 lg:row-start-1 lg:row-end-2 lg:mt-20",
    aspectClasses: "aspect-[4/3]"
  }, {
    id: 3,
    title: "Hardware Lab",
    spec: "Advanced / soldering station",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hardware_setup.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hardware_setup.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/hardware_setup.png-wvc-sizes",
      alt: "Hardware lab setup with tools"
    },
    gridClasses: "lg:col-start-9 lg:col-end-13 lg:row-start-2 lg:row-end-3",
    aspectClasses: "aspect-square"
  }, {
    id: 4,
    title: "Workshop Series",
    spec: "Weekly / skill building",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/workshop_session.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/workshop_session.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/workshop_session.png-wvc-sizes",
      alt: "Workshop session in progress"
    },
    gridClasses: "lg:col-start-2 lg:col-end-6 lg:row-start-3 lg:row-end-4 lg:mt-16",
    aspectClasses: "aspect-[4/3]"
  }, {
    id: 5,
    title: "Discord Hub",
    spec: "Digital / community chat",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/discord_community.png",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/discord_community.png-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/discord_community.png-wvc-sizes",
      alt: "Discord community interface"
    },
    gridClasses: "lg:col-start-6 lg:col-end-10 lg:row-start-3 lg:row-end-5",
    aspectClasses: "aspect-[3/4]"
  }, {
    id: 6,
    title: "Build Nights",
    spec: "Collaborative / late-night",
    image: {
      src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/build_night.webp",
      srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/build_night.webp-wvc-srcset",
      sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701217/img/build_night.webp-wvc-sizes",
      alt: "Late night build session"
    },
    gridClasses: "lg:col-start-10 lg:col-end-13 lg:row-start-4 lg:row-end-5",
    aspectClasses: "aspect-square"
  }];
  return <section data-section-id="2781" id="project-repository" className="bg-background text-foreground py-20 md:py-28 lg:py-36 px-6 md:px-10 lg:px-16">
      <div className="max-w-[1400px] mx-auto">
        {}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8 mb-16 md:mb-24 items-start">
          
          <div className="md:col-span-7">
            <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">
              Community Highlights
            </p>
            <h2 className="font-default font-semibold text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-foreground">
              Recent club activity
            </h2>
          </div>
          <div className="md:col-span-4 md:flex md:justify-end md:items-end md:h-full">
            <Link to="/CommunityPage" className="group inline-flex items-center gap-2 font-mono text-xs uppercase tracking-widest text-foreground border-b border-border pb-1 hover:border-primary transition-colors duration-500">
              <span>View full gallery</span>
              <ArrowUpRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-1 group-hover:-translate-y-1" strokeWidth={1.5} />
            </Link>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 lg:grid-rows-[auto_auto_auto_auto] gap-6 md:gap-8">
          {artifacts.map((item, i) => <Link key={item.id} data-index={i} to="/CommunityPage" className={`group relative block overflow-hidden rounded-lg bg-card ${item.gridClasses}`}>
              <div className={`relative w-full overflow-hidden ${item.aspectClasses}`}>
                <img src={item.image.src} data-wvc-srcset={item.image.srcset} data-wvc-sizes={item.image.sizes} alt={item.image.alt} loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]" />

                {}
                <div className="absolute top-4 left-4 z-10">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-white bg-primary/80 backdrop-blur-sm px-2 py-1 rounded-md">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>

                {}
                <div className="absolute inset-x-0 bottom-0 h-2/5 bg-card/90 backdrop-blur-sm translate-y-full group-hover:translate-y-0 transition-transform duration-700 ease-out flex flex-col justify-center px-6 md:px-8">
                  <h3 className="font-default text-xl md:text-2xl text-foreground leading-tight mb-2">
                    {item.title}
                  </h3>
                  <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                    {item.spec}
                  </p>
                </div>

                {}
                <div className="absolute top-4 right-4 z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="font-mono text-[10px] uppercase tracking-widest text-white bg-primary px-3 py-1.5 rounded-md inline-flex items-center gap-1.5">
                    Explore
                    <ArrowUpRight className="size-3" strokeWidth={1.5} />
                  </span>
                </div>
              </div>
            </Link>)}
        </div>

        {}
        <div className="mt-20 md:mt-28 pt-8 border-t border-border flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
            CODE HUB — Community technology collective
          </p>
          <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
            Six of forty-two events documented
          </p>
        </div>
      </div>
    </section>;
}